import {inject, Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {SnackbarService} from "projects/nter-ui-kit/src/lib/framework/util/service/snackbar.service";

@Injectable({
  providedIn: 'root'
})
export class NavigationUtilsService {
  private _router: Router = inject(Router);
  private _snackbar: SnackbarService = inject(SnackbarService);

  public openLinkInNewTab(link: string): void {
    window.open(this.sanitiseUrl(link), '_blank', 'noopener noreferrer');
  }

  public sanitiseUrl(url: string) {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    return '//' + url;
  }

  public navigateWithQueryParams(
    uri: string,
    message?: string | null,
    queryParams?: any
  ): Promise<boolean> {

    if (message) {
      this._snackbar.openSnackBar(message);
    }

    return this._router.navigate([uri], {queryParams})
      .catch((error: string) => {
        console.log(error);
        return false;
      });
  }
}
